import React from "react";

import Table from "../../common/Table";
import Option from "../../common/RowOption";

import { Link } from "react-router-dom";

const DataTable = ({ data, query }) => {
  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "name",
      label: "نام (فارسی)",

      content: (e) => <Link to={`/mis/discounts/types/${e.id}`}>{e.name}</Link>,
    },
    {
      path: "name_en",
      label: "نام انگلیسی",
    },
    { path: "total", label: "مجموعه" },
    {
      path: "option",
      content: (e) => (
        <Option
          Delete={{ route: "students/discounts/types", id: e.id }}
          Edit={{
            form: "discount-type",
            cache: e.id,
            edit: e,
          }}
        />
      ),
    },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default DataTable;
